import React, { useContext, createContext, } from 'react';
const InspectionDetailContext = createContext({
    canEditInspection: false,
    inspection: undefined,
    onInspectionMutated: undefined,
    isShare: false,
    isPopulatingData: false,
});
export const InspectionDetailProvider = ({ children, value }) => (React.createElement(InspectionDetailContext.Provider, { value: value }, children));
export const useInspectionDetailContext = () => useContext(InspectionDetailContext);
